<template>
  <div class="middle-ellipsis d-flex flex-nowrap align-items-center" ref="flex">
    <div class="sized-breadcrumb" ref="breadcrumb">{{ breadcrumb }}</div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      breadcrumbItems: [],
    };
  },
  computed: {
    breadcrumb() {
      return this.breadcrumbItems.join(' > ');
    },
  },
  watch: {
    breadcrumbItems() {
      this.$nextTick(() => {
        let containerWidth = this.$refs.flex.clientWidth;
        let breadcrumbWidth = this.$refs.breadcrumb.clientWidth;

        if (
          containerWidth < breadcrumbWidth &&
          this.breadcrumbItems.length > 2
        ) {
          let number = this.breadcrumbItems[1] === '...' ? 2 : 1;
          this.breadcrumbItems.splice(1, number, '...');
        }
      });
    },
  },
  mounted() {
    this.breadcrumbItems = this.items;
  },
};
</script>

<style lang="scss" scoped>
.middle-ellipsis {
  margin-top: 4px;
  min-width: 544px;
  overflow: hidden;
}
.sized-breadcrumb {
  font-size: 12px;
  color: $grey-6-mayday;
}
</style>
